import React from 'react';
import { inputClasses, selectClasses } from 'swag-client-common/components/pickers/ecommerce-select';
import selectCssClasses from 'swag-client-common/components/pickers/ecommerce-select/ecommerce-select.scss';
import Input from '@material-ui/core/Input';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Color from 'swag-client-common/components/ui/color';
import classes from './crinkle-paper-picker.scss';
const menuProps = {
  classes: {
    list: classes.menuRoot,
    paper: classes.paperRoot
  },
  anchorOrigin: {
    vertical: 'top',
    horizontal: 'right'
  },
  transformOrigin: {
    vertical: 'top',
    horizontal: 'left'
  },
  getContentAnchorEl: null
};
const menuItemClasses = {
  root: classes.menuItemRoot
};
export default function CrinklePaperPicker(props) {
  const {
    boxItemsId,
    crinklePaperOption,
    onChangeCrinklePaperOption,
    crinklePaperVariants
  } = props;
  const [isSelectOpened, changeSelectOpenState] = React.useState(false);
  const labelsByValue = crinklePaperVariants.reduce((acc, option) => {
    acc[option.value] = option.name;
    return acc;
  }, {});
  return /*#__PURE__*/React.createElement(Select, {
    autoWidth: true,
    input: /*#__PURE__*/React.createElement(Input, {
      classes: inputClasses
    }),
    disableUnderline: true,
    displayEmpty: true,
    classes: selectClasses,
    variant: "filled",
    value: crinklePaperOption === null ? '' : crinklePaperOption,
    MenuProps: menuProps,
    onOpen: () => changeSelectOpenState(true),
    onClose: e => {
      if (!e.currentTarget.dataset.ignoreClick) {
        changeSelectOpenState(false);
      }
    },
    open: isSelectOpened,
    renderValue: selected => selected === '' ? /*#__PURE__*/React.createElement("div", {
      className: selectCssClasses.placeholder
    }, "Select an option") : labelsByValue[selected],
    onChange: e => {
      e.stopPropagation();
      e.preventDefault();
    }
  }, crinklePaperVariants.map(({
    value,
    color,
    name
  }) => /*#__PURE__*/React.createElement(MenuItem, {
    classes: menuItemClasses,
    "data-ignore-click": true,
    key: color,
    value: value
  }, /*#__PURE__*/React.createElement(Color, {
    onClick: () => {
      changeSelectOpenState(false);
      onChangeCrinklePaperOption(boxItemsId, value);
    },
    name: name,
    key: color,
    color: color,
    isActive: value === crinklePaperOption,
    className: classes.colorBadge,
    tooltipText: name,
    isActionable: true,
    showTooltip: true
  }))));
}